if (!customElements.get('product-description')) {
  class ProductDescription extends HTMLElement {
    connectedCallback() {
      this.unitToggle = this.querySelector('[data-product-description-unit-toggle]');
      this.toggleLabel = this.querySelector('[data-product-description-toggle-label]');
      this.values = [...this.querySelectorAll('[data-product-description-value]')];

      this.prepareValues();
      if (this.unitToggle && !this.values.some((valueElement) => Number.isFinite(Number(valueElement.dataset.value)))) {
        this.unitToggle.hidden = true;
      }

      this.onUnitClick = () => {
        const nextUnit = this.unitToggle?.dataset.unit === 'in' ? 'mm' : 'in';
        this.setUnit(nextUnit);
      };
      this.unitToggle?.addEventListener('click', this.onUnitClick);

      if (this.unitToggle && !this.unitToggle.hidden) this.setUnit('mm');
    }

    disconnectedCallback() {
      this.unitToggle?.removeEventListener('click', this.onUnitClick);
    }

    static unitToMm(value, unit) {
      const normalized = String(unit || 'mm').toLowerCase().replace(/[^a-z]/g, '');
      if (normalized === 'in' || normalized === 'inch' || normalized === 'inches') return value * 25.4;
      if (normalized === 'cm' || normalized === 'centimeter' || normalized === 'centimeters' || normalized === 'centimetre' || normalized === 'centimetres') return value * 10;
      if (normalized === 'm' || normalized === 'meter' || normalized === 'meters' || normalized === 'metre' || normalized === 'metres') return value * 1000;
      if (normalized === 'mm' || normalized === 'millimetre' || normalized === 'millimetres') return value;
      if (normalized === 'ft' || normalized === 'foot' || normalized === 'feet') return value * 304.8;
      if (normalized === 'yd' || normalized === 'yard' || normalized === 'yards') return value * 914.4;
      return value;
    }

    prepareValues() {
      this.values.forEach((valueElement) => {
        if (valueElement.dataset.value) return;

        const sourceText = String(valueElement.dataset.sourceText || valueElement.textContent || '').trim();
        const match = sourceText.match(/([-+]?\d+(?:[.,]\d+)?)\s*(mm|millimet(?:er|re)s?|cm|centimet(?:er|re)s?|m|met(?:er|re)s?|in|inch(?:es)?|ft|feet?|yd|yards?)?/i);
        if (!match) return;

        const value = Number(match[1].replace(',', '.'));
        if (!Number.isFinite(value)) return;

        valueElement.dataset.value = String(value);
        valueElement.dataset.unit = match[2] || 'mm';
      });
    }

    setUnit(unit) {
      if (!this.unitToggle || !['mm', 'in'].includes(unit)) return;

      this.unitToggle.dataset.unit = unit;
      this.unitToggle.setAttribute('aria-pressed', unit === 'in' ? 'true' : 'false');
      if (this.toggleLabel) this.toggleLabel.textContent = unit === 'mm' ? 'Show in inches' : 'Show in mm';

      this.values.forEach((valueElement) => {
        const sourceValue = Number(valueElement.dataset.value);
        if (!Number.isFinite(sourceValue)) return;

        const millimeters = ProductDescription.unitToMm(sourceValue, valueElement.dataset.unit);
        if (unit === 'in') {
          valueElement.textContent = `${(millimeters / 25.4).toFixed(2)} in`;
        } else {
          valueElement.textContent = `${millimeters.toFixed(1).replace(/\.0$/, '')} mm`;
        }
      });
    }
  }

  customElements.define('product-description', ProductDescription);
}
